import Swal from 'sweetalert2';

import { types } from "../types/types";
import { fetchConToken, archivoConToken } from '../helpers/fetch';
import { openModal, openModalBottom } from './ui';

export const startNewSucursal = ( values, swal = true ) => {
    return async( dispatch, getState ) => {
        try {
            const resp = await fetchConToken( 'sucursales', { sucursal: values, empresa: values.empresa }, 'POST' );
            const body = await resp.json();
            if( body.ok ) {
                const datos = {
                    text: [ `Sucursal ${ values.nombre } creada correctamente` ],
                    timeOut: 3
                }
                dispatch( openModalBottom( datos ) );
                dispatch( addNewSucursal( body.sucursal._id, body.sucursal ) );
            }else{
                console.log('Error!!!');
                console.log(body.errors);
            }
        } catch (error) {
            console.log('Error!!!');
            console.log( error );
            const datos = {
                title: 'Error',
                text: [ 'Ha habido un error' ],
                buttonText: 'Cerrar'
            }
            dispatch( openModal( datos ) );
        }
    }
};

export const activeSucursal = ( _id, sucursal ) => ({
    type: types.sucursalesActive,
    payload: {
        _id,
        ...sucursal
    }
});

export const unactiveSucursal = () => ({
    type: types.sucursalesUnactive
});

export const addNewSucursal = ( _id, sucursal ) => ({
    type: types.sucursalesAddNew,
    payload: {
        _id,
        ...sucursal
    }
})

export const startLoadingSucursales = ( empresa ) => {
    return async( dispatch, getState ) => {
        const state = getState();
        
        if (state.sucursales.sucursales && state.sucursales.sucursales.length > 0) {
            const sucursalesEmpresa = state.sucursales.sucursales.filter(s => s.empresa === empresa);
            if (sucursalesEmpresa.length > 0) {
                return;
            }
        }
        
        try {
            const resp = await fetchConToken( 'sucursales/empresa', {empresa}, 'POST' );
            const body = await resp.json();
            dispatch( setSucursales( body.sucursales ));
        } catch (error) {
            console.log(error);
        }
    }
};

/**
 * EX-619: comercio POSMS guardado de una sucursal.
 *
 * Es la única lectura que lo devuelve (EX-618): el campo es `select: false` en el schema y el
 * endpoint que puebla el store de sucursales es público y proyecta por allowlist, así que ni ese
 * ni ningún otro lo traen. Solo lo atiende un rol de plataforma; desde cualquier otro responde
 * 401 y aquí se traduce a "no se ha podido leer", no a "no tiene comercio": son cosas distintas
 * y la pantalla las pinta distinto.
 *
 * No pasa por el store: el comercio es un secreto de integración y no tiene por qué quedarse en
 * Redux, donde lo leería cualquier pantalla del panel.
 */
export const startLoadingComercioPosms = ( sucursalId ) => {
    return async() => {
        try {
            const resp = await fetchConToken( `sucursales/${ sucursalId }/comercio-posms` );
            const body = await resp.json();
            if( !body.ok ) {
                return { ok: false, msg: body.msg || 'No se ha podido leer el comercio POSMS' };
            }
            return { ok: true, posmsMerchantUuid: body.posmsMerchantUuid || '' };
        } catch (error) {
            console.log( error );
            return { ok: false, msg: 'No se ha podido leer el comercio POSMS' };
        }
    }
};

export const setSucursales = ( sucursales ) => ({
    type: types.sucursalesLoad,
    payload: sucursales
})

export const startSaveSucursal = ( sucursal, swal = true ) => {
    return async( dispatch, getState ) => {
        
        try {
            const resp = await fetchConToken( `sucursales/${ sucursal._id }`, { sucursal, empresa: sucursal.empresa }, 'PUT' );
            const body = await resp.json();
            if ( body.ok ) {
                console.log( body );
                dispatch( refreshSucursal( sucursal._id, body.sucursal ) );
                const datos = {
                    text: [ `Se han guardado los cambios en ${ sucursal.nombre }` ],
                    timeOut: 3
                }
                dispatch( openModalBottom( datos ) );
            } else {
                console.log( body );
                const datos = {
                    title: 'Error',
                    text: [ body.msg ],
                    buttonText: 'Cerrar'
                }
                dispatch( openModal( datos ) );
            }

            
        } catch (error) {
            console.log(error);
        }
    }
};

export const refreshSucursal = ( id, sucursal ) => ({
    type: types.sucursalesUpdated,
    payload: {
        ...sucursal
    }
});

export const startUploading = ( archivo, idSucursal ) => {

    return async ( dispatch, getState ) => {
        try {
            Swal.fire({
                title: 'Subiendo...',
                text: 'Por favor, espere...',
                allowOutsideClick: false,
                onBeforeOpen: () => {
                    Swal.showLoading();
                }
            });

            const formData = new FormData();
            formData.append('archivo', archivo);
            formData.append('file_name', 'archivo');
    
            const resp = await archivoConToken( `sucursales/upload/${ idSucursal }`, formData, 'POST' );
            const body = await resp.json();

            console.log( body );

            Swal.close();
        } catch (error) {
            throw new Error();
        }  

        Swal.close();
    }
};

export const sucursalStartDelete = ( id, empresa ) => {
    return async( dispatch, getState ) => {

        try {
            const resp = await fetchConToken( `sucursales/${ id }`, { empresa }, 'DELETE' );
            const body = await resp.json();

            if ( body.ok ) {
                console.log( body, id );
                dispatch( sucursalDeleted( id ) );
            } else {
                const datos = {
                    title: 'Error',
                    text: [ body.msg ],
                    buttonText: 'Cerrar'
                }
                dispatch( openModal( datos ) );
            }

            
        } catch (error) {
            console.log(error);
        }
    }
}

const sucursalDeleted = ( id ) => ({
    type: types.sucursalesDelete,
    payload: id
});

export const sucursalLogout = () => ({
    type: types.sucursalesLogoutCleaning
});
